/**
 * Trạng thái trả hồ sơ
 */
export default {
  NotReturn: 0, // chưa gửi trả
  ReSubmit: 1, // đã gửi trả, được nộp lại
  NotReSubmit: 2, // đã gửi trả, không được nộp lại
}
